/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import axios from 'axios';
import d3 from '../globalexports/d3.export';
import MapConst from '../constants/map.constant';
import ChartConst from '../constants/chart.constant';

const applicationDataSource = () => {
  const content = {};
  content.airportsListing = null;
  content.radarSiteListing = null;
  content.avwxData = null;
  function setSvgSourcePath(data) {
    const parser = new window.DOMParser();
    const xmlDoc = parser.parseFromString(data, 'text/xml');
    const importedNode = document.importNode(xmlDoc.documentElement, true);
    // return "sdasdasdasd";
    return d3.select(importedNode).select('path').attr('d');
  }

  content.sources = () => {
    axios.get(ChartConst.planeSource).then((response) => {
      ChartConst.planePath = setSvgSourcePath(response.data);
    });
    axios.get(ChartConst.cloudOptions['1'].cloudSource).then((response) => {
      ChartConst.cloudOptions['1'].cloudPath = setSvgSourcePath(response.data);
    });
    axios.get(ChartConst.cloudOptions['2'].cloudSource).then((response) => {
      ChartConst.cloudOptions['2'].cloudPath = setSvgSourcePath(response.data);
    });
    axios.get(ChartConst.cloudOptions['3'].cloudSource).then((response) => {
      ChartConst.cloudOptions['3'].cloudPath = setSvgSourcePath(response.data);
    });
    axios.get(MapConst.mapDarkStyleSource).then((response) => {
      MapConst.mapStyle.dark = response.data;
    });
    axios.get(MapConst.mapLightStyleSource).then((response) => {
      MapConst.mapStyle.light = response.data;
    });
  };
  content.sources();
  return content;
};
export default applicationDataSource();
